/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import { SCHOOL_SETTING_SERVICE_GROUP } from '@app/constants/schoolSetting.const';
import { MergedProperty } from '../types';
import SettingItem from './SettingItem';

interface ServiceTableProps {
    items: MergedProperty[];
    onChange: (value: any, code: string) => void;
}

/**
 * Table riêng cho SERVICE group – danh sách sổ sách với checkbox
 */
const ServiceTable = ({ items, onChange }: ServiceTableProps) => {
    const sortedList = _.orderBy(
        items.map((o) => {
            const checkFunc = SCHOOL_SETTING_SERVICE_GROUP.find((x) =>
                x?.listCode.includes(o.ps_code),
            );
            return {
                ...o,
                typeCate: checkFunc?.typeCate,
                category: checkFunc?.typeCate === 1 ? 'Dinh dưỡng' : 'Thu chi',
            };
        }),
        ['typeCate', 'p_sortorder'],
        ['asc', 'asc'],
    ).map((o, idx) => ({ ...o, sortOrder: idx + 1 }));

    return (
        <div className="panel-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <table className="table table-togglable table-hover table-bordered footable-loaded footable">
                            <thead className="grey-light">
                                <tr>
                                    <th
                                        className="text-center"
                                        data-toggle="true"
                                        style={{ width: '5%' }}
                                    >
                                        STT
                                    </th>
                                    <th className="text-center">Tên báo cáo</th>
                                    <th className="text-center">Phân hệ</th>
                                    <th
                                        className="text-center"
                                        style={{ width: '5%' }}
                                    >
                                        Chọn in
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedList.map((item) => (
                                    <SettingItem
                                        key={item.ps_id}
                                        item={item}
                                        kidGroupList={[]}
                                        proPackagingCache={[]}
                                        invoiceForm={[]}
                                        onChange={onChange}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceTable;
